import TYPES from '@/modules/shared/types';

// Domain
import { CustomerCellphoneRepository }
  from '../../domain/repository/customer-cellphone-respository';
import { CustomerCellphoneEntity } from '../../domain/entities/customer-cellphone-entity';
import { CustomerCellphoneDto } from '../../domain/dtos/customer-cellphone-dto';
import Injectable from '@/modules/shared/domain/di/injectable';
import Inject from '@/modules/shared/domain/di/inject';
import HttpConnector from '@/modules/shared/domain/connectors/http';

@Injectable()
export class CustomerCellphoneHttpRepository implements CustomerCellphoneRepository {
  @Inject(TYPES.HTTP_CONNECTOR)
  private readonly http_connector!: HttpConnector;

  private readonly endpoint = `${process.env.VUE_APP_API_URL}/api/v1/app/on-boarding/cellphones/`;

  create(customer_cellphone: CustomerCellphoneDto): Promise<void> {
    return new Promise((resolve, reject) => {
      this.http_connector.execute(this.endpoint, 'POST', customer_cellphone)
        .then((response) => {
          response.json()
            .then(({ success, data, message }) => {
              if (success) {
                resolve(data);
              } else {
                reject(new Error(message));
              }
            });
        })
        .catch(reject);
    });
  }

  get(): Promise<Array<CustomerCellphoneEntity>> {
    return new Promise((resolve, reject) => {
      this.http_connector.execute(this.endpoint)
        .then((response) => {
          response.json()
            .then(({ success, data, message }) => {
              if (success) {
                resolve(data);
              } else {
                reject(new Error(message));
              }
            });
        })
        .catch(reject);
    });
  }
}
